// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__oSrKt","advtTitle":"Advt_advtTitle__Ag5EA","firstLineTitle":"Advt_firstLineTitle__fqGGR","secondLineTitle":"Advt_secondLineTitle__E9dBx"};